import React from 'react'
import { Link } from 'react-router-dom'
import GetInTouchImage from "../assets/GetInTouch.jpg";

const GetInTouch = () => {
  return (
    <div>
        <div className="relative w-full min-h-[325px] bg-cover bg-center flex items-center justify-center" style={{backgroundImage: `URL(${GetInTouchImage})`}} >
            <div className="absolute inset-0 bg-black bg-opacity-60"></div>
                <div className="relative text-center text-white px-4 md:px-8 max-w-4xl">
                    <h3 className="text-lg md:text-xl mb-2">Get in touch with</h3>
                    <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">OZ Wide Cover</h1>
                    {/* <div className="h-1 w-12 bg-yellow-500 mx-auto mb-4"></div> */}
                    <p className="text-sm md:text-base mb-6">OZ Wide to better serve you. Our team has years of experience in helping you have the right commercial insurance for your vehicle needs. Call for a quote today!</p>
                    <Link to='/quote' className="bg-yellow-500 text-white py-2 px-6 md:px-8 rounded-full shadow hover:bg-yellow-600 transition">Get a Quote</Link>
                </div>
        </div>
    </div>
  )
}

export default GetInTouch
